import _ from "lodash";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import constant from "../resources/constant";
import utils from "../resources/utils";
import {
  hide_loader,
  set_buiness_list,
  set_user_details,
  get_user_details,
  set_reciver_details,
  set_selected_business,
  set_sender_details,
  show_loader,
} from "../actions/app";
import api_requests from "../resources/api_requests";
import { getCurrentLocation } from "../resources/get_current_location";
import { useTheme } from "../ThemeContext";

export function useLoginSuccess() {
  const dispatch = useDispatch();

  const loginSuccess = useCallback((res) => {
    utils._storeData(constant.AUTH_TOKEN, res?.data?.token);
    const data = {
      first_name: res?.data?.info?.first_name,
      last_name: res?.data?.info?.last_name,
      email: res?.data?.info?.meta_info?.email,
      mobile: res?.data?.info?.mobile,
    };
    utils._storeData(constant.USER_DETIALS, data);

    dispatch(set_user_details(data));
    dispatch(set_buiness_list(res?.data?.info?.business_info));
    dispatch(hide_loader());
  }, []);

  return { loginSuccess };
}

export function useOnBusinessSelect() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateTheme } = useTheme();

  const onBusinessSelect = useCallback(async (business_selected) => {
    const auth_token = utils._retrieveData(constant.AUTH_TOKEN);
    const type = {
      id: business_selected?.type_of_owner || 4,
    };
    utils.setRequestAuthHeader(auth_token, type);

    utils.setRequestAuthHeaderBusinessId(
      business_selected?.business_id,
      business_selected?.parent_id
    );
    utils._storeData(constant.SELECTED_BUSINESS, business_selected);
    utils._storeData(
      constant.SELECTED_BUSINESS_ID,
      business_selected?.business_id
    );
    dispatch(set_selected_business(business_selected));
    dispatch(get_user_details(updateTheme));

    try {
      dispatch(show_loader());
      const response = await api_requests.get_saved_address({
        recent_count: 0,
        saved_count: 20,
        master_zone_id: 0,
      });
      const filtered = _.filter(response.data.saved, (item) => {
        return (
          _.isEmpty(item?.meta_info?.type) || item?.meta_info.type == "pickup"
        );
      });
      if (_.isEmpty(filtered)) {
        dispatch(set_sender_details({}));
        dispatch(set_reciver_details({}));
        console.log("in success state before", response);
        navigate("/", { replace: true });
        dispatch(hide_loader());
        return;
      }
      let near_location;
      if (filtered.length >= 2) {
        const currentLocation = await getCurrentLocation();
        if (currentLocation?.coordinates) {
          near_location = utils.find_nearest_location(
            filtered,
            currentLocation?.coordinates
          );
        }
      } else {
        near_location = filtered[0];
      }
      const user_data = utils._retrieveData(constant.USER_DETIALS);
      const data = {
        id: near_location?.id,
        address_name: near_location?.address_line1,
        address_line1: near_location?.address_line1,
        city: near_location?.city,
        state: near_location?.state,
        pincode: String(near_location?.pincode) || "00000",
        coordinates: {
          latitude: near_location?.exact_location?.latitude,
          longitude: near_location.exact_location?.longitude,
        },
        formatted_address: `${_.get(near_location, "name", "")} ${
          near_location.google_maps_address
        }`.trim(),
        label: near_location?.label,
        name: !_.isEmpty(near_location?.poc)
          ? near_location?.poc[0]?.name
          : user_data?.first_name,
        mobile: !_.isEmpty(near_location?.poc)
          ? near_location?.poc[0]?.mobile
          : user_data?.mobile,
      };
      dispatch(set_sender_details(data));
      dispatch(set_reciver_details({}));
      console.log("in success state", data);
      navigate("/dashboard", { replace: true });
      dispatch(hide_loader());
    } catch (error) {
      console.log("in error state", error);
      dispatch(set_sender_details({}));
      dispatch(set_reciver_details({}));
      navigate("/", { replace: true });
      dispatch(hide_loader());
    }
  });

  return { onBusinessSelect };
}

export function useLoggedInGuard() {
  const navigate = useNavigate();
  useEffect(() => {
    const auth_token = utils._retrieveData(constant.AUTH_TOKEN);
    if (auth_token) {
      navigate("/");
    }
  }, []);
}

export function useLogout() {
  const navigate = useNavigate();

  const logout = useCallback(() => {
    utils.logout();
    navigate("/login");
  }, []);

  return { logout };
}
